(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geraet-anfragen-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initForm(root) {
    if (root.dataset.gaInit) return;
    root.dataset.gaInit = '1';

    var form = root.querySelector('[data-ga-form]');
    var status = root.querySelector('[data-ga-status]');
    var success = root.querySelector('[data-ga-success]');
    var heading = root.querySelector('.geraet-anfrage__heading');
    var intro = root.querySelector('.geraet-anfrage__intro');
    var submit = root.querySelector('[data-ga-submit]');
    var fileInput = root.querySelector('[data-ga-files]');
    var fileHint = root.querySelector('[data-ga-filehint]');
    var webhook = root.getAttribute('data-webhook') || '';
    var maxFiles = parseInt(root.getAttribute('data-max-files'), 10) || 5;
    var maxTotalBytes = (parseFloat(root.getAttribute('data-max-total-mb')) || 5) * 1024 * 1024;
    var loadTime = Date.now();

    // Alle sichtbaren Texte kommen aus den Theme-Sprachdateien (DE/EN), s. <script data-ga-strings>.
    // Laufzeit-Werte stecken darin als [count]/[size] und werden hier eingesetzt.
    var S = {};
    try { S = JSON.parse(root.querySelector('[data-ga-strings]').textContent); } catch (e) {}
    function fill(tpl, values) {
      var out = String(tpl || '');
      for (var k in values) { out = out.split('[' + k + ']').join(values[k]); }
      return out;
    }

    // Bot-Schutz: JS-Nachweis setzen (nur echte Browser führen das aus)
    var jsc = root.querySelector('[data-ga-jscheck]');
    if (jsc) jsc.value = 'js-ok';

    // Prefill aus URL (?hersteller=…&geraet=…) — aus dem Geräte-Finder übergebbar
    try {
      var qp = new URLSearchParams(window.location.search);
      var hEl = root.querySelector('[data-ga-hersteller]');
      var gEl = root.querySelector('[data-ga-geraet]');
      if (hEl && qp.get('hersteller')) hEl.value = qp.get('hersteller');
      if (gEl && qp.get('geraet')) gEl.value = qp.get('geraet');
      else if (gEl && qp.get('modell')) gEl.value = qp.get('modell');
    } catch (e) {}

    function setStatus(msg, isError) {
      status.textContent = msg || '';
      if (isError) status.setAttribute('data-state', 'error');
      else status.removeAttribute('data-state');
    }
    function setFileHint(msg, isError) {
      fileHint.textContent = msg || '';
      if (isError) fileHint.setAttribute('data-state', 'error');
      else fileHint.removeAttribute('data-state');
    }

    // Nach erfolgreichem Absenden nur noch die Erfolgsmeldung zeigen
    // (Überschrift + Einleitung ausblenden – sie sind dann nicht mehr sinnvoll)
    function showSuccess() {
      if (heading) heading.hidden = true;
      if (intro) intro.hidden = true;
      form.hidden = true;
      success.hidden = false;
    }

    // Datei-Auswahl prüfen: Anzahl + GESAMT-Größe (max. 5 MB zusammen)
    function filesValid() {
      if (!fileInput || !fileInput.files || !fileInput.files.length) { setFileHint(S.fileNone); return true; }
      var files = fileInput.files, total = 0, i;
      if (files.length > maxFiles) { setFileHint(S.errTooManyFiles, true); return false; }
      for (i = 0; i < files.length; i++) { total += files[i].size; }
      var sizeMb = (total / 1048576).toFixed(1);
      if (total > maxTotalBytes) { setFileHint(fill(S.errFilesTooBig, { size: sizeMb }), true); return false; }
      setFileHint(fill(files.length === 1 ? S.filesSelectedOne : S.filesSelectedOther, { count: files.length, size: sizeMb }));
      return true;
    }
    if (fileInput) fileInput.addEventListener('change', filesValid);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setStatus('');

      // Honeypot: von Bot ausgefüllt → still „erfolgreich“ tun, nichts senden
      var hp = form.querySelector('input[name="website"]');
      if (hp && hp.value) { showSuccess(); return; }

      // Pflichtfelder
      var geraet = form.querySelector('[name="geraet"]');
      var email = form.querySelector('[name="email"]');
      if (!geraet.value.trim()) { setStatus(S.errDevice, true); geraet.focus(); return; }
      if (!email.value.trim() || email.value.indexOf('@') === -1) { setStatus(S.errEmail, true); email.focus(); return; }
      // Foto ist Pflicht — ohne Bild kann die Fachabteilung die Kontur nicht konstruieren
      if (!fileInput || !fileInput.files || !fileInput.files.length) {
        setStatus(S.errPhoto, true);
        setFileHint(S.errPhoto, true);
        if (fileInput) fileInput.focus();
        return;
      }
      if (!filesValid()) { setStatus(S.errFiles, true); return; }

      if (!webhook) { setStatus(S.errInactive, true); return; }

      submit.disabled = true;
      setStatus(S.sending);

      var fd = new FormData(form);
      fd.append('quelle', 'Geräte-Anfrage (Shop-Startseite)');
      fd.set('formtime', String(Date.now() - loadTime));   // Bot-Schutz: Sofort-Absenden erkennen
      fd.set('jscheck', 'js-ok');

      fetch(webhook, { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r; })
        .then(function () {
          form.reset();
          showSuccess();
          success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        })
        .catch(function () {
          submit.disabled = false;
          setStatus(S.errSend, true);
        });
    });
  }

  function initAll() { document.querySelectorAll('[data-geraet-anfrage]').forEach(initForm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["geraete-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFinder(root) {
    if (root.dataset.gfInit) return;
    root.dataset.gfInit = '1';

    var submit = root.querySelector('[data-gf-submit]');
    var status = root.querySelector('[data-gf-status]');
    var form = root.querySelector('[data-gf-form]');
    var hCombo = root.querySelector('[data-gf-combo="hersteller"]');
    var mCombo = root.querySelector('[data-gf-combo="modell"]');
    var mInput = mCombo.querySelector('[data-gf-input]');
    var mPhIdle = mInput.getAttribute('placeholder');                                   // vor Hersteller-Wahl
    var mPhActive = mInput.getAttribute('data-gf-active-placeholder') || mPhIdle;        // nach Hersteller-Wahl
    var data = null, loading = false;

    function setStatus(msg, isError) {
      status.textContent = msg || '';
      if (isError) status.setAttribute('data-state', 'error');
      else status.removeAttribute('data-state');
    }

    // --- Combobox-Factory ---
    function makeCombo(comboEl, getItems, onChange) {
      var input = comboEl.querySelector('[data-gf-input]');
      var list = comboEl.querySelector('[data-gf-list]');
      var open = false, items = [], active = -1, chosen = '';

      function render(filter) {
        var f = (filter || '').trim().toLowerCase();
        var matches = f ? items.filter(function (x) { return x.toLowerCase().indexOf(f) !== -1; }) : items;
        list.textContent = '';
        if (!matches.length) {
          var empty = document.createElement('li');
          empty.className = 'gf-combo__empty';
          empty.textContent = data ? 'Keine Treffer' : 'Geräteliste wird geladen …';
          list.appendChild(empty);
          active = -1;
          return matches;
        }
        var cap = matches.slice(0, 800);
        var frag = document.createDocumentFragment();
        cap.forEach(function (val, i) {
          var li = document.createElement('li');
          li.className = 'gf-combo__option';
          li.setAttribute('role', 'option');
          li.id = comboEl.getAttribute('data-gf-combo') + '-opt-' + i;
          li.textContent = val;
          li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(val); });
          frag.appendChild(li);
        });
        list.appendChild(frag);
        active = -1;
        return cap;
      }
      var visible = [];

      function openList(filter) {
        if (comboEl.classList.contains('gf-combo--disabled')) return;
        visible = render(filter);
        list.hidden = false;
        comboEl.classList.add('gf-combo--open');
        input.setAttribute('aria-expanded', 'true');
        open = true;
      }
      function closeList() {
        list.hidden = true;
        comboEl.classList.remove('gf-combo--open');
        input.setAttribute('aria-expanded', 'false');
        open = false; active = -1;
      }
      function highlight(idx) {
        var opts = list.querySelectorAll('.gf-combo__option');
        opts.forEach(function (o) { o.removeAttribute('aria-selected'); });
        if (idx >= 0 && idx < opts.length) {
          opts[idx].setAttribute('aria-selected', 'true');
          opts[idx].scrollIntoView({ block: 'nearest' });
          input.setAttribute('aria-activedescendant', opts[idx].id);
          active = idx;
        }
      }
      function choose(val) {
        chosen = val; input.value = val;
        closeList();
        onChange(val);
      }

      input.addEventListener('focus', function () { items = getItems(); openList(input.value === chosen ? '' : input.value); });
      input.addEventListener('click', function () { if (!open) { items = getItems(); openList(input.value === chosen ? '' : input.value); } });
      input.addEventListener('input', function () { items = getItems(); openList(input.value); onChange(null); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); if (!open) { items = getItems(); openList(''); } highlight(Math.min(active + 1, list.querySelectorAll('.gf-combo__option').length - 1)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(Math.max(active - 1, 0)); }
        else if (e.key === 'Enter') {
          var opts = list.querySelectorAll('.gf-combo__option');
          if (open && active >= 0 && opts[active]) { e.preventDefault(); choose(opts[active].textContent); }
        } else if (e.key === 'Escape') { closeList(); }
      });
      // Schließen nur, wenn der Fokus die Combobox WIRKLICH verlässt (z. B. Tab/anderes Feld).
      // Ein Klick auf den Scrollbalken der Liste hat relatedTarget=null → Liste bleibt offen & scrollbar.
      comboEl.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !comboEl.contains(e.relatedTarget)) closeList();
      });
      // Mausklick außerhalb der Combobox → schließen (Scrollbalken zählt als „innerhalb“).
      document.addEventListener('mousedown', function (e) {
        if (open && !comboEl.contains(e.target)) closeList();
      });
      comboEl.querySelector('.gf-combo__arrow').addEventListener('mousedown', function (e) {
        e.preventDefault();
        if (open) closeList(); else { input.focus(); items = getItems(); openList(''); }
      });

      return {
        value: function () { return chosen; },
        reset: function () { chosen = ''; input.value = ''; },
        refresh: function () { if (open) { items = getItems(); visible = render(input.value === chosen ? '' : input.value); } },
        enable: function (on) {
          comboEl.classList.toggle('gf-combo--disabled', !on);
          input.disabled = !on;
        }
      };
    }

    var hsCombo = makeCombo(hCombo, function () { return data ? Object.keys(data) : []; }, function (val) {
      // Hersteller geändert → Modell zurücksetzen
      msCombo.reset();
      var valid = val && data && Object.prototype.hasOwnProperty.call(data, val);
      msCombo.enable(!!valid);
      mInput.setAttribute('placeholder', valid ? mPhActive : mPhIdle);   // „Modell wählen“, sobald Hersteller steht
      refreshSubmit();
    });
    var msCombo = makeCombo(mCombo, function () {
      var h = hsCombo.value();
      return (data && data[h]) ? Object.keys(data[h].m) : [];
    }, function () { refreshSubmit(); });

    function refreshSubmit() {
      var h = hsCombo.value(), m = msCombo.value();
      var ok = data && data[h] && Object.prototype.hasOwnProperty.call(data[h].m, m);
      submit.disabled = !ok;
    }

    function loadData(dringend) {
      if (data || loading) return;
      loading = true;
      setStatus('Geräteliste wird geladen …', false);
      // Kollektionsseite: Teil-Liste der Kategorie; fehlt sie (noch), Gesamtliste nehmen
      function hole(url) {
        return fetch(url, { priority: dringend ? 'high' : 'low' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      }
      hole(root.dataset.src)
        .catch(function (e) { if (root.dataset.srcFallback) return hole(root.dataset.srcFallback); throw e; })
        .then(function (json) { data = json; setStatus('', false); hsCombo.refresh(); })
        .catch(function () { setStatus('Die Geräteliste konnte nicht geladen werden. Bitte lade die Seite neu oder nutze unten „Gerät anfragen“.', true); })
        .finally(function () { loading = false; });
    }
    // Datenbasis erst nach dem Seitenaufbau laden: die Gesamtliste ist ~160 KB und würde sonst
    // mit dem Startbild um die Leitung konkurrieren. Wer vorher in den Finder tippt, startet das Laden sofort.
    function sofort() { loadData(true); }
    ['focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
      root.addEventListener(ev, sofort, { once: true, passive: true });
    });
    function spaeter() {
      if ('requestIdleCallback' in window) window.requestIdleCallback(function () { loadData(false); }, { timeout: 2000 });
      else setTimeout(function () { loadData(false); }, 200);
    }
    if (document.readyState === 'complete') spaeter();
    else window.addEventListener('load', spaeter, { once: true });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var h = hsCombo.value(), m = msCombo.value();
      if (!data || !data[h]) { setStatus('Bitte einen Hersteller aus der Liste wählen.', true); return; }
      if (!Object.prototype.hasOwnProperty.call(data[h].m, m)) { setStatus('Bitte ein Modell aus der Liste wählen.', true); return; }
      // Suchbegriff = "Hersteller Modell" (sinnvoll im Suchfeld/Titel statt "*"); Filter grenzt exakt ein
      var params = ['q=' + encodeURIComponent(h + ' ' + m), 'options%5Bprefix%5D=last'], hf = data[h].h, mf = data[h].m[m], i;
      for (i = 0; i < hf.length; i++) params.push('filter.p.m.custom.hersteller=' + encodeURIComponent(hf[i]));
      for (i = 0; i < mf.length; i++) params.push('filter.p.m.custom.modell=' + encodeURIComponent(mf[i]));
      window.location.href = '/search?' + params.join('&');
    });
  }

  function initAll() { document.querySelectorAll('[data-geraete-finder]').forEach(initFinder); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
